export default __webpack_public_path__ + "static/media/nft.a2d9c64b.jpeg";